module.exports = __webpack_public_path__ + "static/media/Avenir-Medium.77d901f5.woff";